// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__lmcLf","flower":"style_flower__Hyqg_","spin":"style_spin__g12EQ"};